// extracted by mini-css-extract-plugin
export var defaultWrapper = "_h3-3";
export var downloadButton = "_h3-4";
export var fileContainer = "_h3-9 _h3-7";
export var fileContainerBase = "_h3-7";
export var fileContainerBaseSm = "_h3-a _h3-7";
export var fileContainerFixedHeight = "_h3-8 _h3-7";
export var fileContainerFixedHeightSm = "_h3-c _h3-a _h3-7";
export var fileContainerSm = "_h3-b _h3-a _h3-7";
export var fileInfo = "_h3-5";
export var fileInfoWidthRestricted = "_h3-6";
export var fileType = "_h3-1";
export var fileTypeName = "_h3-2";
export var fileTypeSm = "_h3-d _h3-1";
export var image = "_h3-0";
export var link = "_h3-f";
export var overflowEllipsis = "_h3-e";